"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorizeServiceRequest = exports.authenticateUser = void 0;
function authenticateUser(authentication, app) {
    if (authentication && typeof authentication == 'string') {
        return app.auth().verifyIdToken(authentication.split('Bearer ')[1]);
    }
    else
        return Promise.reject("Authentication error");
}
exports.authenticateUser = authenticateUser;
function authorizeServiceRequest(authorization, token) {
    if (authorization && typeof authorization == 'string') {
        if (authorization.split('Bearer ')[1] === token)
            return Promise.resolve();
    }
    return Promise.reject(new Error("Invalid authentication or authorization token"));
}
exports.authorizeServiceRequest = authorizeServiceRequest;
//# sourceMappingURL=auth-helpers.js.map